<li routerLinkActive="active">
  <a [routerLink]="[linksTo,queryParams]">
    <i aria-hidden="true">○</i> {{label}}
  </a>
</li>
